import { useEffect, useState } from 'react'

const UNDO_MS = 5000

/**
 * Fixed bottom toast with undo for bulk remove.
 * @param {{ count: number, label?: string, onUndo: () => void, onDismiss: () => void, isMobile?: boolean }} props
 */
export default function PantryRemoveUndoToast({
  count,
  label = 'items',
  onUndo,
  onDismiss,
  isMobile = false,
}) {
  const [progress, setProgress] = useState(100)

  useEffect(() => {
    const start = Date.now()
    let frame = 0
    const tick = () => {
      const pct = Math.max(0, 100 - ((Date.now() - start) / UNDO_MS) * 100)
      setProgress(pct)
      if (pct > 0) {
        frame = requestAnimationFrame(tick)
      } else {
        onDismiss()
      }
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [onDismiss])

  if (count <= 0) return null

  return (
    <div
      className={`pantry-remove-undo-toast${isMobile ? ' pantry-remove-undo-toast--mobile' : ''}`}
      role="status"
    >
      <span className="pantry-remove-undo-toast__text">
        <strong>
          {count} {label}
        </strong>{' '}
        removed
      </span>
      <button type="button" className="pantry-remove-undo-toast__undo" onClick={onUndo}>
        Undo
      </button>
      <div className="pantry-remove-undo-toast__bar" aria-hidden="true">
        <div className="pantry-remove-undo-toast__bar-fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  )
}
